import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageManager from './PageManager';
import FieldTools from '../FieldTools';
import { templateActions } from '../../../redux/actions';
import { Container, Paper, PaperRatio, PaperContent, ContentRender, ContentGrid } from './SheetBuilder.styles';

export default () => {

    const rows = 52;
    const cols = 32;
    const pageManager = useRef(null);
    const gridRef = useRef([]);
    const renderRef = useRef([]);
    const contentRef = useRef(null);

    const dispatch = useDispatch();
    const fieldTool = useSelector(state => state.templateState.tool);
    const fieldProps = useSelector(state => state.templateState.props);
    const loadedContent = useSelector(state => state.templateState.loadedContent);
    const numPages = useSelector(state => state.templateState.pages);
    const [selectedId, setSelectedId] = useState(null);

    const setPropAndId = useCallback((id, props) => {
        setSelectedId([id,props]); 
    }, []);

    useEffect(() => {
        pageManager.current = new PageManager();
        pageManager.current.setRows(rows);
        pageManager.current.setCols(cols);
        pageManager.current.setRenderTarget(renderRef.current);
        pageManager.current.setPageChangeCallback((pages) => {dispatch(templateActions.setNumPages(pages))});
        pageManager.current.setOnSelect((id, props) => {setPropAndId(id, props)});
        pageManager.current.setExport((exported) => {dispatch(templateActions.setContent(exported))});
        pageManager.current.setOnModifyContent(({minPages}) => {dispatch(templateActions.setMinNumPages(minPages))});

        RenderCellsNotManaged(1);

        const copyField = (e) => { e.target.tagName === 'BODY' ? pageManager.current.toClipboard(e) : pageManager.current.clearClipboard()};
        const pasteField = (e) => { e.target.tagName === 'BODY' && pageManager.current.fromClipboard(e)};
        const mouseUp = () => {pageManager.current.mouseUp();}
        const resizeFn = () => {pageManager.current.resize();}
        resizeFn();

        window.addEventListener('resize', resizeFn);
        window.addEventListener('mouseup', mouseUp);

        //window.addEventListener('keydown', contentKeyDown);
        window.addEventListener('copy', copyField);
        window.addEventListener('paste', pasteField);

        return () => {
            window.removeEventListener('resize', resizeFn);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('copy', copyField);
            window.removeEventListener('paste', pasteField);
            dispatch({type:'RESET'});
        }
    }, [dispatch, setPropAndId]);

    useEffect(() => {
        pageManager.current.syncTemplatePages(numPages);
        pageManager.current.reimport();
        RenderCellsNotManaged(numPages);
    }, [numPages]);

    useEffect(() => {
        if (loadedContent) {
            pageManager.current.import(loadedContent);
            dispatch(templateActions.setContent(loadedContent));
        }
    }, [dispatch, loadedContent]);

    useEffect(() => {
        if (fieldTool === FieldTools.REMOVE) {
            pageManager.current.removeSelected();
            dispatch(templateActions.setAddFieldTool(null));
            return;
        }

        pageManager.current.setTool(fieldTool);

    }, [dispatch, fieldTool]);

    useEffect(() => {
        dispatch(templateActions.setSelected(selectedId ? selectedId[1] : null, selectedId ? selectedId[0] : null));
        dispatch(templateActions.setAddFieldTool(null));
    }, [dispatch, selectedId]);

    useEffect(() => {
        pageManager.current.setNumPages(numPages);
    }, [dispatch, numPages]);

    useEffect(() => {
        pageManager.current.setFieldProps(fieldProps);
        dispatch(templateActions.setContent(pageManager.current.export()));
    }, [dispatch, fieldProps]);

    const RenderCellsNotManaged = (pages) => {
        for(let p=0; p<pages; p++) {
            gridRef.current[p].innerHTML = '';

            for(let i=0; i<rows; i++) {
                let row = document.createElement('div');
                row.classList.add('template-row');

                for(let j=0; j<cols; j++) {
                    let col = document.createElement('div');
                    col.classList.add('template-col');
                    col.addEventListener('mousedown', (e) => pageManager.current ? pageManager.current.mouseDown(e, j, i, p) : null);
                    col.addEventListener('mousemove', (e) => pageManager.current ? pageManager.current.mouseMove(e, j, i, p) : null);
                    row.append(col);
                }

                gridRef.current[p].append(row);
            }
        }
    }

    return <Container className="scrollbar">
        {Array(numPages).fill(0).map((a, page) => <Paper key={page}>
            <PaperRatio>
                <PaperContent className={fieldTool ? 'hasTool' : ''} ref={contentRef}>
                    <ContentRender ref={el => renderRef.current[page] = el} cols={cols} rows={rows} className="content-render" />
                    <ContentGrid ref={el => gridRef.current[page] = el} />
                </PaperContent>
            </PaperRatio>
        </Paper>)}
    </Container>;
};